export default {
  COMMON_Validation: {
    IC: "Masukkan nombor sahaja tanpa '-'",
  },
};
